import { Controller, FieldErrors } from "react-hook-form";
import "../../Checkbox/style.css";
import Checkbox from "../../Checkbox";

type TControlledCheckboxProps = {
  name: string;
  error?: string | FieldErrors;
  label: string;
  required?: boolean;
  control: any;
  className?: string;
  disabled?: boolean;
};

const ControlledCheckbox = ({ name, error, label, required, control, className, disabled }: TControlledCheckboxProps) => {
  const getErrorMessage = (): string | undefined => {
    if (!error) return undefined;

    if (typeof error === "string") {
      return error;
    }

    // Navega pela estrutura aninhada de erros usando o caminho do name
    // Ex: "address.street" -> error.address.street
    if (typeof error === "object") {
      const nameParts = name.split(".");
      let currentError: any = error;

      for (const part of nameParts) {
        if (currentError && typeof currentError === "object" && part in currentError) {
          currentError = currentError[part];
        } else {
          return undefined;
        }
      }

      return currentError?.message as string | undefined;
    }

    return undefined;
  };

  const errorMessage = getErrorMessage();

  return (
    <Controller
      disabled={disabled}
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Checkbox name={name} label={label} value={value} onChange={onChange} error={errorMessage} required={required} />
      )}
    />
  );
};

export default ControlledCheckbox;
